let canvas;

/* 控制下雪 */
function SnowFall(snow = {}) {
  /* 可配置属性 */
  this.maxFlake = snow.maxFlake || 200; /* 最多片数 */
  this.flakeSize = snow.flakeSize || 3; /* 雪花形状 */
  this.fallSpeed = snow.fallSpeed || 0.1; /* 坠落速度 */
}
/* 兼容写法 */
const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  function (callback) {
    setTimeout(callback, 1000 / 60);
  };

const cancelAnimationFrame =
  window.cancelAnimationFrame ||
  window.mozCancelAnimationFrame ||
  window.webkitCancelAnimationFrame ||
  window.msCancelAnimationFrame ||
  window.oCancelAnimationFrame;
/* 开始下雪 */
SnowFall.prototype.start = function () {
  /* 创建画布 */
  this.ctx = canvas.getContext('2d');
  /* 创建雪花形状 */
  CreateFlakes.apply(this);
  /* 画雪 */
  DrawSnow.apply(this);
};
/* 雪运动对象 */
function FlakeMove(canvasWidth, canvasHeight, flakeSize, fallSpeed) {
  this.x = Math.floor(Math.random() * canvasWidth); /* x 坐标 */
  this.y = Math.floor(Math.random() * canvasHeight); /* y 坐标 */
  this.size = Math.random() * flakeSize + 2; /* 形状 */
  this.maxSize = flakeSize; /* 最大形状 */
  this.speed = (Number(Math.random()) + fallSpeed) / 1.8; /* 坠落速度 */
  this.fallSpeed = fallSpeed; /* 坠落速度 */
  this.velY = this.speed; /* Y 方向速度 */
  this.velX = 0; /* X 方向速度 */
  this.stepSize = Math.random() / 40; /* 步长 */
  this.step = 0; /* 步数 */
}
FlakeMove.prototype.update = function () {
  const x = this.x;
  const y = this.y;
  /* 左右摆动(余弦) */
  this.velX *= 0.95;
  if (this.velY <= this.speed) {
    this.velY = this.speed;
  }
  this.velX += Math.cos((this.step += 0.05)) * this.stepSize;

  this.y += this.velY;
  this.x += this.velX;
  /* 飞出边界的处理 */
  if (this.x >= canvas.clientWidth || this.x <= 0 || this.y >= canvas.height || this.y <= 0) {
    this.reset(canvas.clientWidth, canvas.height);
  }
};
/* 飞出边界-放置最顶端继续坠落 */
FlakeMove.prototype.reset = function (width, height) {
  this.x = Math.floor(Math.random() * width);
  this.y = 0;
  this.size = Math.random() * this.maxSize + 2;
  this.speed = (Number(Math.random()) + this.fallSpeed) / 1.8;
  this.velY = this.speed;
  this.velX = 0;
};
// 渲染雪花-随机形状（此处可修改雪花颜色！！！）
FlakeMove.prototype.render = function (ctx) {
  const snowFlake = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size);
  snowFlake.addColorStop(0, 'rgba(255, 255, 255, 0.9)'); /* 此处是雪花颜色，默认是白色 */
  snowFlake.addColorStop(0.5, 'rgba(255, 255, 255, 0.5)'); /* 若要改为其他颜色，请自行查 */
  snowFlake.addColorStop(1, 'rgba(255, 255, 255, 0)'); /* 找 16 进制的 RGB 颜色代码。 */
  ctx.save();
  ctx.fillStyle = snowFlake;
  ctx.beginPath();
  ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
};
/* 创建雪花-定义形状 */
function CreateFlakes() {
  const maxFlake = this.maxFlake;
  const flakes = (this.flakes = []);
  for (let i = 0; i < maxFlake; i++) {
    flakes.push(new FlakeMove(canvas.clientWidth, canvas.height, this.flakeSize, this.fallSpeed));
  }
}
/* 画雪 */
function DrawSnow() {
  const maxFlake = this.maxFlake;
  const flakes = this.flakes;
  const ctx = this.ctx
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const that = this
  /* 清空雪花 */
  ctx.clearRect(0, 0, canvas.clientWidth, canvas.height);
  for (let e = 0; e < maxFlake; e++) {
    flakes[e].update();
    flakes[e].render(ctx);
  }
  /*  一帧一帧的画 */
  this.loop = requestAnimationFrame(function () {
    DrawSnow.apply(that);
  });
}

export const start = function (el) {
  canvas = el;
  canvas.width = el.clientWidth;
  canvas.height = el.clientHeight;
  // eslint-disable-next-line new-cap
  const snow = new SnowFall({ maxFlake: Math.floor(el.clientWidth / 50) });
 
  snow.start();
};
